import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { CommonReportingStandardModel } from '../model';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: CommonReportingStandardModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class CrsSelfCertificationStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<CommonReportingStandardModel>((_, data) => ({
    state: 'valid',
    data: CommonReportingStandardModel.fromJson(data),
  }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));

  constructor() {
    super(initialState);
  }
}
